export default __webpack_public_path__ + "static/media/editicon.7327be08.svg";